import { render, staticRenderFns } from "./BridgedGasBarSection.vue?vue&type=template&id=5117dbff&scoped=true"
import script from "./BridgedGasBarSection.vue?vue&type=script&lang=ts"
export * from "./BridgedGasBarSection.vue?vue&type=script&lang=ts"
import style0 from "./BridgedGasBarSection.vue?vue&type=style&index=0&id=5117dbff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117dbff",
  null
  
)

export default component.exports